import type { ArealplanQuery } from '@origo/planregister';
import type { PlanFilters, SortOption } from './types';

export function hasActiveFilters(f: PlanFilters): boolean {
    return (
        f.statuses.length > 0 ||
        f.plantyper.length > 0 ||
        f.lovreferanser.length > 0 ||
        f.kommuner.length > 0 ||
        f.dateFrom !== null ||
        f.dateTo !== null
    );
}

export function countActiveFilters(f: PlanFilters): number {
    let count = f.statuses.length + f.plantyper.length + f.lovreferanser.length + f.kommuner.length;
    if (f.dateFrom) count++;
    if (f.dateTo) count++;
    return count;
}

/**
 * Søk, filtre og sortering som én spørring mot hele planregisteret. Filtrering
 * og sortering skjer i tjenesten (lazy loading, #14578) — se
 * `matchesArealplanQuery` i @origo/planregister for semantikken.
 */
export function toArealplanQuery(filters: PlanFilters, search: string, sort: SortOption): ArealplanQuery {
    return {
        search: search.trim() || undefined,
        statuses: filters.statuses,
        plantyper: filters.plantyper,
        lovreferanser: filters.lovreferanser,
        kommuner: filters.kommuner,
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
        sort: { field: sort.field, direction: sort.direction },
    };
}

/** Dato `months` måneder tilbake i tid (00:00:00). */
export function monthsAgo(months: number): Date {
    const d = new Date();
    d.setMonth(d.getMonth() - months);
    d.setHours(0, 0, 0, 0);
    return d;
}
